import { render } from "./all-rekap_instruktur.vue?vue&type=template&id=5362bfa2"
import script from "./all-rekap_instruktur.vue?vue&type=script&lang=js"
export * from "./all-rekap_instruktur.vue?vue&type=script&lang=js"

import "./all-rekap_instruktur.vue?vue&type=style&index=0&id=5362bfa2&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__